export * from "./tiles.vendors.mapzen";
export * from "./tiles.vendors.google";
//# sourceMappingURL=index.js.map